import { Home, AccessDenied, Login, ResetPasswordPage, ActivityCheckin } from './views'
import ActivityBooking from './views/ActivityBooking'

export default [
    {
        path: "/home",
        name: "home",
        get component() {
            return Home;
        }
    },
    {
        path: "/login",
        name: "login",
        get component() {
            return Login;
        }
    },
    {
        path: "/reset-password",
        name: "ResetPasswordPage",
        get component() {
            return ResetPasswordPage;
        }
    },
    {
        path: '/access-denied',
        name: 'access-denied',
        get component(){
            return AccessDenied;
        }
    },
    {
        path: '/activity-checkin',
        name: 'activity-checkin',
        get component(){
            return ActivityCheckin;
        }
    },
    {
        path: '/activity-booking',
        name: 'activity-booking',
        get component(){
            return ActivityBooking;
        }
    }
];
